import type { ReactNode } from "react";
import { Text } from "@carbon6/c6-frontend-design";
import { PageBase, type PageBaseProps } from "../shell/PageBase";
import { appTextModes } from "../theme";
import styles from "./PlaceholderPage.module.css";

type PlaceholderPageProps = PageBaseProps & {
  // 이 메뉴가 맡을 화면 한 줄 설명 — 준비 중 안내 아래에 그대로 선다.
  description: string;
};

// 메뉴별 실제 화면이 들어오기 전까지 라우트를 채우는 페이지. 셸(사이드바·헤더)은 PageBase 가
// 그리고, 본문은 준비 중 안내 하나다.
export class PlaceholderPage extends PageBase<PlaceholderPageProps> {
  protected override renderContent(): ReactNode {
    return (
      <section className={styles.empty} aria-label="준비 중">
        <Text variant={appTextModes["title-bold"]}>이 화면은 준비 중입니다.</Text>
        <Text variant={appTextModes["body-normal"]} className={styles.description}>
          {this.props.description}
        </Text>
      </section>
    );
  }
}
